<div class="border-0 h-100">
  <div class="card vx-shadow-hover text-center h-100">
    <div class="card-body p-2 bluebackground">
      <h5 class="card-title small mb-1">Product Catalog</h5>
      <img class="img-fluid mx-auto pdfimg" ngSrc="assets/images/header/productbrochurecovernew.webp" alt="VeEX Inc. Product Catalog" title=""
        width="auto" height="auto" loading="lazy">
    </div>
    <div class="card-footer p-2 border-0 bluebackground">
      <div class="text-center btn-green w-100">
        <a class="text-white vx-cursor stretched-link" [href]="brochure"
          target="_blank">{{ 'BUTTON.DOWNLOAD' | translate }}</a>
      </div>
    </div>
  </div>
</div>
